export default __webpack_public_path__ + "static/media/icon-point.141f682f.svg";